import _ from "lodash";

import { getProtections } from "../root.selectors";
import { RootState } from "../root.reducer";
import { SBSharedProtection } from "./protections.types";
import { getProfileProtection } from "../profiles/profiles.selectors";

export const getProtectionsList = (state: RootState): SBSharedProtection[] => {
  const protections = getProtections(state);

  return _.at(protections.list, protections.keys);
};

export const getProfileProtectionCategories =
  (profileId: string) =>
  (state: RootState): string[] => {
    const protectionLevel = getProfileProtection(profileId)(state);
    const protections = getProtections(state);

    const protection = protections.list[protectionLevel];

    return protection ? protection.categories : [];
  };
